var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            "header-cell-style": { background: "#f2f2f2", color: "black" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operationCenter.ind"),
              width: "60px",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                },
              },
            ]),
          }),
          _vm._l(_vm.tableColumn, function (item, index) {
            return _c("el-table-column", {
              key: index,
              attrs: {
                label: item.label,
                prop: item.prop,
                "min-width": item.minWidth,
                align: item.align,
                fixed: item.fixed,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "pushStatus"
                          ? _c(
                              "div",
                              [
                                scope.row.pushStatus === 0
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "warning",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.statusOptions[
                                                scope.row.pushStatus
                                              ].label
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                scope.row.pushStatus === 1
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "success",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.statusOptions[
                                                scope.row.pushStatus
                                              ].label
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                scope.row.pushStatus === 2
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: { size: "mini", type: "danger" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.statusOptions[
                                                scope.row.pushStatus
                                              ].label
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                scope.row.pushStatus === 3
                                  ? _c(
                                      "el-tag",
                                      { attrs: { size: "mini", type: "info" } },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.statusOptions[
                                                scope.row.pushStatus
                                              ].label
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : item.prop === "mdfeStatus"
                          ? _c(
                              "div",
                              [
                                scope.row.mdfeStatus === 1
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "success",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.mdfeStatus[
                                                scope.row.mdfeStatus
                                              ].label
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                scope.row.mdfeStatus === 2
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: { size: "mini", type: "danger" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.mdfeStatus[
                                                scope.row.mdfeStatus
                                              ].label
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                scope.row.mdfeStatus === 3
                                  ? _c(
                                      "el-tag",
                                      { attrs: { size: "mini", type: "info" } },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.mdfeStatus[
                                                scope.row.mdfeStatus
                                              ].label
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : item.prop === "mdfeKey"
                          ? _c("div", [
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c("div", { staticClass: "ellipsis-key" }, [
                                  _vm._v(_vm._s(scope.row.mdfeKey)),
                                ]),
                                (scope.row.currentMdfeStatus ||
                                  scope.row.currentMdfeStatus === 0) &&
                                scope.row.mdfeStatus !==
                                  scope.row.currentMdfeStatus
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "20px",
                                          cursor: "pointer",
                                          display: "flex",
                                          "align-items": "center",
                                          "justify-content": "end",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              content:
                                                _vm.$t(
                                                  "mdfeTranslate.TheStatusOfMdfeHasBeenChangedTo"
                                                ) +
                                                _vm.mdfeStatus[
                                                  scope.row.currentMdfeStatus
                                                ].label +
                                                "，" +
                                                _vm.$t(
                                                  "mdfeTranslate.PleaseFollow"
                                                ),
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("div", {
                                              staticStyle: {
                                                width: "10px",
                                                height: "10px",
                                                "border-radius": "50%",
                                                background: "#f56c6c",
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ])
                          : _c("div", [
                              _vm._v(
                                " " + _vm._s(scope.row[item.prop] || "-") + " "
                              ),
                            ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: _vm.$t("operationCenter.operate"),
              width: "160",
              align: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permit",
                            rawName: "v-permit:remove",
                            value: "btn:invoiceCenter:airlinePushRecords:view",
                            expression:
                              "'btn:invoiceCenter:airlinePushRecords:view'",
                            arg: "remove",
                          },
                        ],
                        attrs: { type: "text", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleView(scope.row, 5)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticStyle: { color: "#409eff !important" } },
                          [_vm._v(_vm._s(_vm.$t("GlobalSetObj.View")))]
                        ),
                      ]
                    ),
                    scope.row.pushStatus === 0
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:invoiceCenter:airlinePushRecords:push",
                                expression:
                                  "'btn:invoiceCenter:airlinePushRecords:push'",
                                arg: "remove",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAviationPush(scope.row, 2)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { color: "#409eff !important" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("mdfeTranslate.AviationPush"))
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    scope.row.pushStatus === 2
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:invoiceCenter:airlinePushRecords:rePush",
                                expression:
                                  "'btn:invoiceCenter:airlinePushRecords:rePush'",
                                arg: "remove",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAviationPush(scope.row, 3)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("mdfeTranslate.RePush")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    scope.row.pushStatus === 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:invoiceCenter:airlinePushRecords:cancel",
                                expression:
                                  "'btn:invoiceCenter:airlinePushRecords:cancel'",
                                arg: "remove",
                              },
                            ],
                            staticStyle: { color: "#f00" },
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleView(scope.row, 4)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("mdfeTranslate.Cancel")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }